import HeaderCard from './HeaderCard';

export default HeaderCard;
